import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { updateMaterialLayout } from "#modules/materialLayouts/infra/updateMaterialLayout.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const useUpdateMaterialLayout = ({
  quoteRequestLineId,
  options,
}: {
  quoteRequestLineId: string | undefined;
  options?: {
    onSuccess?: () => void;
    onError?: (err: Error) => void;
    onMutate?: () => void;
  };
}) => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, ...rest } = useMutation({
    mutationFn: updateMaterialLayout,
    onMutate: () => {
      options?.onMutate?.();
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.quoteRequestLines.detail(quoteRequestLineId),
      });
      options?.onSuccess?.();
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);

      options?.onError?.(err);
    },
  });

  return {
    updateMaterialLayout: mutate,
    updateMaterialLayoutAsync: mutateAsync,
    ...rest,
  };
};
